<template>
    <ValidationProvider
        :name="name"
        :rules="rules"
        :class="classWrapper"
        tag="div"
    >
        <label
            :class="[
                'cb-container',
                `type${type}`,
                noMarginBottom && 'no-margin-bottom',
            ]"
        >
            <span>{{ label }}</span>
            <input
                v-bind="$attrs"
                value="1"
                @input="onInput"
                :id="name"
                :disabled="disabled"
                type="checkbox"
                :checked="value"
            />
            <span :class="['cb-checkmark', `type${type}`]"></span>
        </label>
    </ValidationProvider>
</template>

<script>
export default {
    name: 'CheckboxField',
    props: {
        label: String,
        value: {
            type: [String, Boolean, Number],
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        rules: {
            type: [String, Array, Object],
        },
        classWrapper: {
            type: String,
        },
        disabled: Boolean,
        type: {
            type: String,
            default: '1',
        },
        noMarginBottom: Boolean,
    },
    data() {
        return {
            isChecked: false,
        };
    },
    created() {
        this.isChecked = this.value;
    },
    methods: {
        onInput() {
            this.isChecked = !this.isChecked;
            this.$emit('input', this.isChecked);
        },
    },
};
</script>

<style lang="scss" scoped>
/* The container */
.cb-container {
    display: block;
    position: relative;
    padding: 0;
    padding-left: 35px;
    margin-bottom: 30px;
    cursor: pointer;
    font-size: 14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #7c7c7a;
    &.type2 {
        font-size: 16px !important;
        margin-bottom: 24px;
    }
    &.no-margin-bottom {
        margin-bottom: 0;
    }
}

/* Hide the browser's default checkbox */
.cb-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

/* Create a custom checkbox */
.cb-checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #e1e7e9;
    border-radius: 5px;
    &.type2 {
        background-color: #fff;
        border: 2px solid #7c7c7a;
    }
}

/* On mouse-over, add a grey background color */
.cb-container:hover input ~ .cb-checkmark {
    background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.cb-container input:checked ~ .cb-checkmark {
    background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.cb-checkmark:after {
    content: '';
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.cb-container input:checked ~ .cb-checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.cb-container .cb-checkmark:after {
    left: 8px;
    top: 5px;
    width: 8px;
    height: 11px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>
